<template>
    <div
        class="salepage-product__select tw-grid tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-6 lg:tw-gap-4"
    >
        <div
            class="tw-mb-0 tw-col-span-1"
            v-for="(item, index) in salePageProduct"
            :key="index"
            @click="openProductDetail(item)"
        >
            <div
                v-if="queueQuantity(item) > 0"
                class="qty tw-flex tw-justify-center tw-align-middle"
                :style="
                    `border: 2px solid ${salePage.button_color}; background-color: #ffffff`
                "
            >
                <div class="tw-self-center tw-font-bold tw-text-md">
                    {{ queueQuantity(item) }}
                </div>
            </div>
            <div class="image-container tw-rounded-lg">
                <img
                    :src="item.image_url"
                    class="image-grid tw-w-full tw-rounded-lg"
                    :alt="item.name"
                />
            </div>
            <div class="tw-p-2 lg:-p-4">
                <div class="p-text">
                    <div
                        style="height: 1.5rem; width: 100%;"
                        class="tw-text-justify p-text tw-truncate tw-text-ellipsis"
                        :class="{ 'text-white': isbgDark }"
                    >
                        {{ item.name }}
                    </div>
                    <div
                        style="height: 1.5rem;"
                        class="non-mobile p-text tw-truncate tw-text-ellipsis tw-text-gray-400 tw-text-xs"
                    >
                        {{ removeTag(item.description) }}
                    </div>
                </div>
                <div class="tw-flex tw-justify-between tw-mt-2 tw-leading-4">
                    <div>
                        <div>
                            <small
                                v-if="
                                    parseFloat(item.price) <
                                        parseFloat(item.price_full)
                                "
                                class="tw-text-red-500 tw-text-sm tw-tracking-tight tw-font-semibold tw-font-sans "
                            >
                                {{ currency ? currency.symbol : ""
                                }}{{
                                    Number(item.price).toLocaleString(
                                        undefined,
                                        {
                                            minimumFractionDigits: 2
                                        }
                                    )
                                }}
                            </small>
                            <small
                                v-if="
                                    parseFloat(item.price) >=
                                        parseFloat(item.price_full)
                                "
                                class="tw-text-black tw-text-sm tw-tracking-tight tw-font-semibold tw-font-sans"
                                :class="{'text-white': isbgDark }"
                            >
                                {{ currency ? currency.symbol : ""
                                }}{{
                                    Number(item.price).toLocaleString(
                                        undefined,
                                        {
                                            minimumFractionDigits: 2
                                        }
                                    )
                                }}
                            </small>
                        </div>
                        <div class="tw-leading-4">
                            <small
                                v-if="
                                    parseFloat(item.price) <
                                        parseFloat(item.price_full)
                                "
                                class="tw-line-through tw-text-xs tw-tracking-tight tw-font-sans"
                                :class="{'text-white': isbgDark }"
                            >
                                {{ currency ? currency.symbol : ""
                                }}{{
                                    Number(item.price_full).toLocaleString(
                                        undefined,
                                        {
                                            minimumFractionDigits: 2
                                        }
                                    )
                                }}
                            </small>
                        </div>
                    </div>

                    <div v-if="salePage.type == 'sale'">
                        <button
                            v-if="parseFloat(item.stock_balance) > 0"
                            class="btn btn-sm btn-salepage text-cart-button tw-rounded-full tw-py-1"
                            :style="
                                `background-color: ${salePage.button_color}; color: ${salePage.button_text};`
                            "
                            v-on:click.stop="addToCart(item.id)"
                        >
                            <i class="fa fa-shopping-bag tw-mr-1"></i>
                            เพิ่มสินค้า
                        </button>
                        <button
                            v-if="parseFloat(item.stock_balance) <= 0"
                            class="btn btn-light btn-sm btn-block tw-rounded-full tw-text-xs"
                            disabled
                        >
                            สินค้าหมด
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Detailed Product -->
        <salepage-body-detail-product-component
            :productDetailOpen="productDetailOpen"
            :product="productDetail"
            :salePage="salePage"
            :currency="currency"
            :queueQuantity="queueQuantity(productDetail)"
            @closeProductDetail="closeProductDetail"
            @addToCart="addToCart"
        >
        </salepage-body-detail-product-component>
    </div>
</template>
<script>
export default {
    props: ["salePageProduct", "salePage", "currency", "queue", "isbgDark"],
    data() {
        return {
            productDetailOpen: false,
            productDetail: null
        };
    },
    methods: {
        addToCart(productId, quantity = 1) {
            this.$emit("addToCart", productId, quantity);
        },
        queueQuantity(product) {
            if (product) {
                let queueProduct = this.queue.find(
                    item => item.product_id == product.id
                );
                return queueProduct ? queueProduct.quantity : 0;
            }
        },
        openProductDetail(product) {
            this.productDetailOpen = true;
            this.productDetail = product;
        },
        closeProductDetail() {
            this.productDetailOpen = false;
            this.productDetail = null;
        },
        removeTag(str) {
            if (str === null || str === "") {
                return "";
            } else {
                str = str.toString();
            }
            str = str.replace(/(<([^>]+)>)/gi, "");
            str = str.replace(/&[^;]+;/g, "");

            return str;
        }
    }
};
</script>
<style scoped>
@media screen and (max-width: 748px) {
    .text-cart-button {
        font-size: 10px;
        line-height: 12px;
    }

    .non-mobile {
        display: none;
    }
    .grid-items {
        width: 165px;
    }
}

@media screen and (min-width: 749px) {
    .text-cart-button {
        font-size: 12px;
        line-height: 16px;
    }

    .grid-items {
        width: 200px;
    }

    .btn-salepage:hover {
        box-shadow: inset 0px 0px 0px 2000px rgba(0, 0, 0, 0.25);
        transition: all 0.25s ease;
    }
}

.image-container {
    width: 100%;
    aspect-ratio: 1 / 1;
}

.image-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.btn-salepage:active {
    box-shadow: 0 0 0 0.2rem rgba(1, 1, 1, 0.25);
    transition: all 0.25s ease;
}
.qty {
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 9999px;
    margin: -10px -10px;
    z-index: 10;
}
</style>
